var StepStatus;
(function (StepStatus) {
    StepStatus[StepStatus["completed"] = 0] = "completed";
    StepStatus[StepStatus["pending"] = 1] = "pending";
})(StepStatus || (StepStatus = {}));

//components

export { StepStatus };
//# sourceMappingURL=core-models.es5.js.map
